export const Scripts: BattleScriptsData = {
	gen: 9,
};
